
const eventview = [{"key":"eventview.title","string":"Vložené akce"},{"key":"eventview.add_event_button","string":"Vložit akci"},{"key":"eventview.no_event_added","string":"Zatím jste na mezinárodní odbornou platformu nevložil žádnou akci. "},{"key":"eventview.table.title","string":"Název"},{"key":"eventview.table.location","string":"Místo"},{"key":"eventview.table.date","string":"Datum"},{"key":"eventview.gotowebsite","string":"Přejít na stránku akce"}]

export default eventview



// WEBPACK FOOTER //
// ./src/i18n/cs/addevent/eventview.js